import * as React from "react";
import "@progress/kendo-react-intl";
import "@progress/kendo-react-dropdowns";
import "react-router-dom";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import * as api from "../../api/index";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import documentIcon from "../../assets/fileIcons/Document.svg";
import {
    clearMattersBalances,
    getMattersBalances,
} from "actions/matters.action";
import styles from "../BatchPosting/BatchPosting.module.scss";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { Button } from "@progress/kendo-react-buttons";
import MatterAccount from "../MatterLedger/MatterAccount";
import { AmountFormatCell, DateFormatCell } from "components/common/formatter";
import { PayCell } from "components/BatchPosting/GridComponents";
import { PostingSubmitFilter } from "components/BatchPosting/SubmitFunction";
import Form from "components/BatchPosting/Form";
import MatterDetails from "pages/MatterLedger/MatterDetails";
import { TransactionPeriod } from "components/common/TransactionPeriod";
import { toast } from "react-toastify";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { LINQ_STATUS } from "CONSTANT/statusCodes";
import OtpInput from "components/common/OtpInput";

const BatchPostings = ({ type, selectedList, onClose }) => {
    const editField = "inEdit";
    const [errorModal, setErrorModal] = useState(false);
    const [updateDataIndex, setUpdateDataIndex] = useState(0);
    const [vatCode, setVatCode] = useState(null);
    const [loading, setLoading] = useState(false);
    const [currentTransactionPeriod, setCurrentTransactionPeriod] = useState();
    const [initialData, setInitialData] = useState({
        date: new Date(),
    });
    const dispatch = useDispatch();

    const [matterref, setmatterref] = useState(null);
    const [showChits, setShowChits] = useState(false);

    const [list, setList] = useState([]);
    const [renderList, setRenderList] = useState([]);
    const [updateResetData, setUpdateResetData] = useState({});
    const [selectedPostingCode, setSelectedPostingCode] = useState(null);
    const [item, setitem] = useState([
        { code: "0", name: "Loading", displayFields: [] },
    ]);
    const [matterId, setMatterId] = useState(null);
    const [matterIdTo, setMatterIdTo] = useState(null);
    const [filesData, setFilesData] = useState([]);

    const [isUpdate, setIsUpdate] = useState(false);
    const [postingCode, setPostingCode] = useState();

    const [showAuthDialog, setShowAuthDialog] = useState(false);
    const [authErrorMsg, setAuthErrorMsg] = useState("");
    const [failedPostings, setFailedPostings] = useState([]);
    const [pendingPayload, setPendingPayload] = useState(null);
    const [authCode, setAuthCode] = useState("");

    const handleAuthCodeChange = (code) => {
        setAuthCode(code || "");
    };

    useEffect(() => {
        if (type === "chitPosting") {
            setList([...selectedList]);
        }
    }, [selectedList]);

    const onChagngePosting = (event) => {
        const code = event?.value?.code;
        if (code === "PIN") {
            setRenderList(["PIN"]);
        }
        if (code === "DIN") {
            setRenderList(["DIN"]);
        }
        if (code === "OCR") {
            setRenderList(["OCR"]);
        }
        if (code === "ODR") {
            setRenderList(["ODR"]);
        }
        if (code === "CCR") {
            setRenderList(["CCR"]);
        }
        if (code === "CDR") {
            setRenderList(["CDR"]);
        }
        if (code === "DDR") {
            setRenderList(["DDR"]);
        }
        if (code === "DCR") {
            setRenderList(["DCR"]);
        }
        if (code === "DUU") {
            setRenderList(["DUU"]);
        }
        if (code === "CTO") {
            setRenderList(["CTO"]);
        }
        if (code === "OTC") {
            setRenderList(["OTC"]);
        }
        if (code === "BR") {
            setRenderList(["BR"]);
        }
        if (code === "BP") {
            setRenderList(["BP"]);
        }
        if (code === "BT") {
            setRenderList(["BT"]);
        }
        if (code === "DPU") {
            setRenderList(["DPU"]);
        }
        if (code === "CTC") {
            setRenderList(["CTC"]);
        }
        if (code === "OTN") {
            setRenderList(["OTN"]);
        }
        if (code === "NTO") {
            setRenderList(["NTO"]);
        }
        if (code === "NTB") {
            setRenderList(["NTB"]);
        }
        setSelectedPostingCode(code);
    };

    const handleRemove = (row) => {
        if (list.length === 0) return;
        const listcopy = [...list];
        listcopy.splice(row, 1);
        setList([...listcopy]);
    };

    const handleSubmit = async (e) => {
        const data = PostingSubmitFilter(list);
        if (data.vatAmount === null) {
            data.vatAmount = 0;
        }

        if (data.length === 0) return;
        const formattedData = data.map((postingItem) => {
            postingItem.transactionPeriod = currentTransactionPeriod?.period;
            return postingItem;
        });
        setLoading(true);
        try {
            const response = await api.createposting(formattedData);
            toast.success(
                `Posted Successfully for ${response?.data?.data[0]?.postingType} - ${response?.data?.data[0]?.transactionNo} `
            );
            setList([]);
            if (onClose) {
                onClose();
            }
        } catch (error) {
            const status = error?.response?.status || error?.status;
            if (status === LINQ_STATUS.PostingOverDrawnException) {
                onPostingOverdrawn(error, formattedData);
            } else if (status !== LINQ_STATUS.LinqUserMessageException) {
                toast.error("Error occured in posting");
            }
        } finally {
            setLoading(false);
        }
    };

    const onPostingOverdrawn = (error, formattedData) => {
        let failed = [];
        let msg = "";
        const backendItems = error?.data.errorData || {};
        failed = backendItems;

        if (!backendItems.length && Array.isArray(formattedData)) {
            failed = formattedData.map((p, i) => ({
                postingType: p?.postingType,
                matterRef: p?.matterRef,
                matterID: p?.matterID,
                message: backendItems?.message || "",
                __derived: true,
                __index: i,
            }));
        }
        setAuthErrorMsg(msg);
        setFailedPostings(failed);
        setPendingPayload(formattedData);
        setAuthCode("");
        setShowAuthDialog(true);
    };

    const findFailedOriginal = (err) => {
        if (!pendingPayload || !Array.isArray(pendingPayload)) return null;
        const byUnique = err?.uniqueId
            ? pendingPayload.find((p) => p?.uniqueId && p.uniqueId === err.uniqueId)
            : null;
        if (byUnique) return byUnique;
        return pendingPayload.find(
            (p) =>
                p?.postingType === err?.postingType && p?.matterID === err?.matterID
        );
    };

    const handleAuthorise = async () => {
        if (!pendingPayload) return;
        setLoading(true);
        try {
            const response = await api.createposting(pendingPayload, {
                allowOverdrawn: true,
                authcode: authCode,
            });
            setShowAuthDialog(false);
            toast.success(
                `Posted Successfully for ${response?.data?.data[0]?.postingType} - ${response?.data?.data[0]?.transactionNo} `
            );
            setList([]);
            if (onClose) {
                onClose();
            }
        } catch (error) {
            const status = error?.response?.status || error?.status;
            if (status === LINQ_STATUS.InvalidUserAuthCode) {
                const respData = error?.response?.data || {};
                setAuthErrorMsg(respData?.message || "Invalid authorisation code.");
                setShowAuthDialog(true);
            } else if (status === LINQ_STATUS.PostingOverDrawnException) {
                onPostingOverdrawn(error, pendingPayload);
            } else {
                setShowAuthDialog(false);
                if (status !== LINQ_STATUS.LinqUserMessageException) {
                    toast.error("Error occured in posting");
                }
            }
        } finally {
            setLoading(false);
        }
    };

    const DocumentCounterCell = (e) => {
        return (
            <td>
                <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
                    {e?.dataItem?.documentCount > 0 && (
                        <>
                            <img
                                role="button"
                                src={documentIcon}
                                alt="Document Icon"
                                onClick={() => { }}
                            ></img>
                        </>
                    )}
                    <span>
                        {e?.dataItem?.documentCount === 0 ? "" : e?.dataItem?.documentCount}
                    </span>
                </div>
            </td>
        );
    };

    const onChangematter = (event) => {
        if (event.value) {
            setMatterId(event.value);
            dispatch(getMattersBalances(event.value.matterId, "All Postings"));
            setmatterref(event.value.matterId);
        } else {
            setMatterId(null);
            setmatterref(null);
            dispatch(clearMattersBalances("All Postings"));
        }
    };

    const handleUpdate = (props) => {
        const { dataIndex, dataItem } = props;
        onChangematter({ value: dataItem.matterID });
        setMatterIdTo(dataItem?.matterIDTo);
        setFilesData(dataItem.documentFiles);
        setUpdateDataIndex(dataIndex);
        setUpdateResetData({ ...dataItem });
        setPostingCode(dataItem.postingType);
        setRenderList([dataItem.postingType.code]);
        setVatCode(dataItem.vatCode);
        setIsUpdate(true);
        setInitialData(dataItem);
    };

    const CommandCell = (props) => {
        return (
            <td style={{ display: "flex", flexDirection: "column" }}>
                <button
                    type="button"
                    onClick={() => handleUpdate(props)}
                    className="k-button k-button-md k-rounded-md "
                >
                    <AiOutlineEdit color="blue" />
                </button>

                <button
                    type="button"
                    style={{ marginTop: "5px" }}
                    onClick={() => handleRemove(props.dataIndex)}
                    className="k-button k-button-md k-rounded-md "
                >
                    <AiOutlineDelete color="red" />
                </button>
            </td>
        );
    };

    return (
        <div className="h-100 pb-3">

            <div className="d-flex h-100 ps-0 ms-0 g-0">
                <Form
                    postingType={type}
                    list={list}
                    setList={setList}
                    setIsUpdate={setIsUpdate}
                    onChagngePosting={onChagngePosting}
                    updateDataIndex={updateDataIndex}
                    setInitialData={setInitialData}
                    matterId={matterId}
                    matterIdTo={matterIdTo}
                    setMatterIdTo={setMatterIdTo}
                    vatCode={vatCode}
                    setVatCode={setVatCode}
                    isUpdate={isUpdate}
                    setErrorModal={() => setErrorModal(true)}
                    setRenderList={setRenderList}
                    renderList={renderList}
                    onChangematter={onChangematter}
                    initialData={initialData}
                    setUpdateDataIndex={setUpdateDataIndex}
                    item={item}
                    changePostingCode={setPostingCode}
                    postingCodeEdit={postingCode}
                    openChits={() => setShowChits(true)}
                    type={type}
                />

                <div className="flex-grow-1 overflow-auto h-100 d-flex flex-column">
                                        
                    <TransactionPeriod
                        reloadIcon
                        onRefreshTransactionPeriod={setCurrentTransactionPeriod}
                    />

                    <div className="mx-3 mt-3 h-100 d-flex flex-column"
                        style={{ minHeight: "110px" }}
                    >

                        {renderList[0] !== "PIN" && (
                            <div className="row mx-0 mt-2 mb-2 gap-1">
                                <div className="col g-0 mb-lg-2 mb-xl-0 p-1">
                                    <MatterDetails matter={matterId} width={"100%"} />
                                </div>
                                <div
                                    className="col-12 col-xxl-6 g-0 mb-lg-2 mb-xl-0 p-1"
                                    style={{ overflowX: "auto" }}
                                >
                                    <MatterAccount
                                        mt="0px"
                                        float="right"
                                        component={"All Postings"}
                                        matterId={matterId}
                                    />
                                </div>
                            </div>
                        )}

                        <div className="mt-3 h-100 w-100 d-flex flex-column">
                            <Grid
                                data={list}
                                editField={editField}
                                className="flex-grow-1 overflow-auto"
                            >
                                <Column
                                    title="Type"
                                    field="postingType.code"
                                    width="70px"
                                    headerClassName="ps-3"
                                />
                                <Column
                                    title="Matter"
                                    field="matterID.matterRef"
                                    width="100px"
                                />
                                <Column title="Nominal" field="nominalRef.nominalRef" />
                                <Column
                                    title="Date"
                                    field="date"
                                    width="100px"
                                    cell={DateFormatCell}
                                />
                                <Column title="Ref" field="reference" width="100px" />
                                <Column title="Detail" field="details" />
                                <Column
                                    title="Net"
                                    field="netAmount"
                                    cell={AmountFormatCell}
                                    width="80px"
                                />
                                <Column
                                    title="Vat"
                                    field="vatAmount"
                                    cell={AmountFormatCell}
                                    width="80px"
                                />
                                <Column title="Supplier" field="supplierRef.supplierRef" />
                                <Column title="FE" field="feeEarnerRef.userRef" />
                                <Column title="Payee(r)" cell={PayCell} width="120px" />
                                <Column
                                    title="Docs"
                                    field="documentFiles"
                                    cell={DocumentCounterCell}
                                    width="80px"
                                />
                                <Column cell={CommandCell} width="60px" />
                            </Grid>

                            <div className="buttonstyle justify-content-end">
                                <Button
                                    className="common-btn"
                                    disabled={loading}
                                    onClick={handleSubmit}
                                >
                                    Post
                                </Button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            {showAuthDialog && (
                <Dialog
                    title={null}
                    onClose={() => setShowAuthDialog(false)}
                    className="dialog-sm"
                >
                    <div className="d-flex flex-column align-items-center justify-content-center px-5 py-4 text-center w-100">
                        <span className="k-icon k-i-warning fs-1 text-warning mb-3" />
                        <h2 className="mb-3 fw-semibold" style={{ color: "#7d7ab4" }}>
                            Authorisation Required
                        </h2>
                        <p className="mb-2 text-secondary">
                            Some postings will overdraw an account and require authorisation.
                        </p>
                        {failedPostings.length > 0 && (
                            <ul
                                className="list-unstyled mt-2 w-100 overflow-auto"
                                style={{ maxHeight: 350 }}
                            >
                                {failedPostings.map((err, idx) => {
                                    const original = findFailedOriginal(err) || {};
                                    return (
                                        <li
                                            key={idx}
                                            className="d-flex align-items-start mb-2 bg-light rounded p-3 text-start shadow-sm"
                                        >
                                            <div className="w-100">
                                                <div className="d-flex justify-content-between gap-3 flex-wrap">
                                                    <div>
                                                        <b>Type:</b> {err.postingType}
                                                    </div>
                                                    <div>
                                                        <b>Matter Ref:</b> {err.matterRef}
                                                    </div>
                                                    {original?.reference && (
                                                        <div>
                                                            <b>Ref:</b> {original.reference}
                                                        </div>
                                                    )}
                                                    {original?.date && (
                                                        <div>
                                                            <b>Date:</b>{" "}
                                                            {new Date(original.date).toLocaleDateString()}
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="d-flex justify-content-between gap-3 flex-wrap mt-2">
                                                    {original?.details && (
                                                        <div className="flex-grow-1">
                                                            <b>Details:</b> {original.details}{" "}
                                                        </div>
                                                    )}
                                                    {typeof original?.netAmount !== "undefined" && (
                                                        <div>
                                                            <b>Net:</b> {original.netAmount}
                                                        </div>
                                                    )}
                                                    {typeof original?.vatAmount !== "undefined" && (
                                                        <div>
                                                            <b>VAT:</b> {original.vatAmount}
                                                        </div>
                                                    )}
                                                </div>
                                                {err.message && (
                                                    <div className="d-flex gap-2 mt-2">
                                                        <b>Message:</b>{" "}
                                                        <p className="text-danger mb-0">{err.message}</p>
                                                    </div>
                                                )}
                                            </div>
                                        </li>
                                    );
                                })}
                            </ul>
                        )}
                        <div className="w-100 mt-3 d-flex flex-column align-items-center justify-content-center">
                            <label className="mb-2 fw-bold">Authorisation Code</label>
                            <OtpInput
                                value={authCode}
                                onChange={handleAuthCodeChange}
                                onComplete={handleAuthCodeChange}
                                length={4}
                            />
                            {authErrorMsg && (
                                <p className="mt-2 text-danger">{authErrorMsg}</p>
                            )}
                        </div>
                    </div>

                    <DialogActionsBar layout="end">
                        <div className={`dialog-footer`}>
                            <Button
                                onClick={() => setShowAuthDialog(false)}
                                className="common-btn bgBtnSecondary border-0 me-2"
                            >
                                Cancel
                            </Button>
                            <Button
                                disabled={authCode.length !== 4}
                                onClick={handleAuthorise}
                                className="common-btn me-4"
                            >
                                Post
                            </Button>
                        </div>
                    </DialogActionsBar>
                </Dialog>
            )}
        </div>
    );
};

export default BatchPostings;
